import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const InctvRbtLineList = ({ inctvRbtId }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      if (!inctvRbtId) return;

      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('inctvRbtId', inctvRbtId));
    },
    [inctvRbtId],
  );

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons);
  };

  return <EntityList entity="INCTV_RBT_LINE" augRowsReq={augRowsReq} augTabButtons={augTabButtons} />;
};
